// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "webcx-web-popup-" + chunkId + "-" + {"580":"b172ab2dae559b5f455d","787":"c0b8178c950055463209","915":"224f4a8e942ef90eec3b"}[chunkId] + ".js";
};